import { Field, reduxForm } from 'redux-form';
import { LoginButton, LoginButtonDisabled } from '../../components/buttons';
import React, { Component } from 'react';
import { renderTextField } from '../../components/reduxFields';
import { connect } from 'react-redux';
import { checkBusinessName, ResetPasswordAction } from './actions/LoginActions';
import { NavLink, Redirect } from 'react-router-dom';
import { subDomainUrlRedirection } from '../../actions/utilAction';
// import validate from './validate';
import Favicon from 'react-favicon';
import LogoImageViewer from '../../components/logoImageViewer';
import { getResetPasswordLinkIsValidAction } from './actions/LoginActions';
import SmallLoader from '../../img/small-loader.gif';

class ResetPassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // errorMessage: null,
      token: props.match.params.token,
    };
  }

  componentWillMount() {
    let subdomain = subDomainUrlRedirection();
    if (subdomain) {
      this.props.checkBusinessName(subdomain);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.businessNameCheck && this.props.businessNameCheck !== prevProps.businessNameCheck) {
      let token = this.props.match.params.token;
      this.props.getResetPasswordLinkIsValidAction(token, this.props.businessNameCheck);
    }
  }

  // componentDidMount() {
  //   debugger;
  //   let token = this.props.match.params.token;
  //   this.props.getResetPasswordLinkIsValidAction(token);
  // }


  onSubmit(authData) {
    authData = {
      'Password': authData.Password,
      'Token': this.state.token,
    };
    this.props.ResetPasswordAction(authData, this.props.businessNameCheck);
  }

  passwordChangeConfirmation = (message) => (
    <div className="login-fields text-center">
      <div className="resetmail_msg">
        <i className="material-icons">tag_faces</i>
        <div className="pt20">
          <p>{message}</p>
          {/* <p>A confimation email sent to your mail with reset password link.Thanks!</p> */}
        </div>
      </div>
      <div className="backtologin text-center"><NavLink exact to="/login"><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</NavLink></div>
    </div>
  );

  renderLoading() {
    return (
      <div className="login_bg">
        <div className="login-wrapper">
          <div className="login-fields">
            Loading...Please wait !
          </div>
        </div>
      </div>);
  }


  renderForm(props) {
    const { handleSubmit } = props;

    return (
      <div className="login-fields" style={{ width: "650px", fontSize: "14px" }}>
        {this.props.loading &&
          (<div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>)
        }
        {this.props.errorMessageForInvalidPass ?
          (<div style={{padding: '1.8rem' }}>

            <div className="alert-danger">{this.props.errorMessageForInvalidPass}</div>
            <div className='text-center'>
              <div className="backtologin text-center"><NavLink exact to="/login"><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</NavLink></div>
            </div>
          </div>)
          : (
            <div>
              <h3>Reset Password </h3>
              <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              {props.errorMessage ? (<div className="alert-danger">{props.errorMessage}</div>) : '' }
                <div style={{ display: "flex" }}>
                  <div className="col-sm-6 col-md-6">
                    <div className="col-sm-12 col-md-12 require">
                      <Field
                        name="Password"
                        type="password"
                        maxLength="30"
                        label="New password"
                        component={renderTextField} />
                    </div>
                    <div className="col-sm-12 col-md-12 require">
                      <Field
                        name="confirm_password"
                        type="password"
                        maxLength="30"
                        label="Confirm password"
                        component={renderTextField} />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 ">
                    <p className="pl-3">Password Criteria</p>
                    <ul>
                      <li>Minimum 8 and maximum 30 characters</li>
                      <li>At least 1 lowercase character</li>
                      <li>At least 1 uppercase character</li>
                      <li>At least 1 number</li>
                      <li>At least 1 special character</li>
                      <li>New password cannot be the same as current password</li>
                    </ul>
                  </div>
                </div>
                <div className="pt20">
                  {props.authenticating ? <LoginButtonDisabled label="Reset" /> : <LoginButton label="Reset" />}
                </div>
                <div className="backtologin text-center"><NavLink exact to="/login"><i className="fa fa-long-arrow-left" aria-hidden="true"></i> Back to Login</NavLink></div>
              </form>
            </div>
          )}
      </div>
    );
  }

  render() {
    const { loaderBusinessToken, authenticatingToken, businessNameCheck } = this.props;
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;

    if (loaderBusinessToken || authenticatingToken) {
      this.renderLoading();
    } else if (!businessNameCheck) {
      return (<Redirect to="/login" />);
    }

    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <Favicon url={this.props.organizationDetails && this.props.organizationDetails.favicon ? this.props.organizationDetails.favicon : ''} />
          <div className="loginlogo">
            <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
          </div>
          {this.props.successMessage ?
            this.passwordChangeConfirmation(this.props.successMessage) :
            this.renderForm(this.props)
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loaderBusinessToken: state.login.loaderBusinessToken,
    businessNameCheck: state.login.businessNameCheck,
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    authenticating: state.login.authenticating,
    errorMessage: state.login.errorMessage,
    successMessage: state.login.successMessage,
    errorMessageForInvalidPass: state.login.errorMessageForInvalidPass,
    organizationDetails: state.login.organizationDetails,
    loading: state.login.loading,
  };
}

function validate(values) {
  const error = {};
  if (!values.Password || values.Password.trim() === '') {
    error.Password = 'Please enter password';
  } else if (!/^(?=.{8,30}$)/.test(values.Password)) {
    error.Password = 'Password should contain minimum 8 and maximum 30 characters';
  } else {
    let pError = [], prefix = '';
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.Password)) {
      prefix = 'Password should contain atleast ';
    }
    if (!/^(?=.*[a-z])/.test(values.Password)) {
      pError.push('1 lowercase character');
    }
    if (!/^(?=.*[A-Z])/.test(values.Password)) {
      pError.push('1 uppercase character');
    }
    if (!/^(?=.*[0-9])/.test(values.Password)) {
      pError.push('1 numeric value');
    }
    if (!/^(?=.*[\+\-\_\@\#\$\%\&\!\,\[\]\{\}\(\)\|])/.test(values.Password)) {
      pError.push('1 special character');
    }
    error.Password = prefix + pError.join(', ');
  }
  if (!values.confirm_password) {
    error.confirm_password = 'Please enter confirm password';
  } else if (values.confirm_password !== values.Password) {
    error.confirm_password = 'Password doesn\'t match';
  }
  return error;
}

ResetPassword = reduxForm({
  form: 'ResetPasswordForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(ResetPassword);

export default connect(mapStateToProps, { ResetPasswordAction, checkBusinessName, getResetPasswordLinkIsValidAction })(ResetPassword);



// WEBPACK FOOTER //
// ./src/modules/logins/reset_password.js